import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

import { ApiConstants } from 'src/app/constants/api-constants';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { HttpGuardService } from 'src/app/guards/http-guard.service';
import { AggregatePayload, AssetConditionPayloadModel, EntitySummaryPayloadModel } from 'src/app/model';

@Injectable({
  providedIn: 'root'
})
export class EntitiesServiceService {

  constructor(private httpGuard: HttpGuardService, private _datePipe: DatePipe,
    public service: ServicecallService) { }

  getEntityDetails(entityId: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.entityProfile, entityId);
  }
  getScoreDetails(entityId: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.scoreDetails, entityId, false);
  }
  getReminderDetails(entityId: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.certificateDetails, entityId, false);
  }
  getDriverDetails(entityId: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.driverDetails, entityId, false);
  }

  getAssetHealthDetails(entityId: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.entityHealthStatus, entityId, false);
  }
  getEntityData(payload) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.entityData, payload, false);
  }
  getAssetCondition(payload) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.entityCondition, payload, false);
  }
  widgetStatus(payload) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.widgetStatus, payload, false);
  }

  entityInsightsStatistics(statPayload: any) {
    const payload = {
      entityId: statPayload.entityId,
      siteId: this.service.getSiteId(),
      from: statPayload.from
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.entityInsightsStatistics, payload, false);
  }

  entityInsightsAttribute(attributePayload: any) {
    const payload = {
      entityId: attributePayload.entityId,
      attribute: attributePayload.attribute,
      from: attributePayload.from,
      to: attributePayload.to
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.entityInsightsAttribute, payload, false);
  }

  activeUsers(userId?: string) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.activeUsers, { userId: userId ? userId : undefined }, false);
  }

  updateEntityData(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.updateEntityData, payload);
  }

  attributeData(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.attributeData, payload, false);
  }

  fetchLanes(reqData: any) {
    const params = '/' + reqData.siteId + '/zones?destination=' + reqData?.destination;
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.fetchLanes, params, false);
  }

  monotainerDetails(reqData: any) {
    const params = reqData?.siteId ? '/' + reqData?.entityId + '?category=' + reqData?.category + '&type=' + reqData?.type + '&byName=false&siteId=' + reqData?.siteId :
      '/' + reqData?.entityId + '?category=' + reqData?.category + '&type=' + reqData?.type + '&byName=false';
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.entitiesDetails, params, false);
  }

  updateRea(reqData: any) {
    const userId: any = localStorage.getItem('userId') ? localStorage.getItem('userId') : null;
    const payload = { zoneIds: reqData?.zones, entityIds: reqData?.entityIds };
    const params = reqData?.siteId ? '?action=rea&scanId=true&userId=' + userId + '&type=entity&siteId=' + reqData?.siteId :
      '?action=rea&scanId=true&userId=' + userId + '&type=entity';
    return this.httpGuard.httpReq('patch', 'API_ENDPOINT', `${ApiConstants.URL.updateRea}${params}`, payload, true);
  }

  getDefaultImageByCategory(type: any) {
    switch (type) {
      case 'monotainer': return '../../../../assets/images/monotainer-grey.svg';
      case 'patient': return '../../assets/images/clinicalUser.svg';
      default: return '../../assets/images/Default-asset_image.svg';
    }
  }

  getMonotainerHistory(payload: any) {
    const siteId = sessionStorage.getItem('siteId') ?
      JSON.parse(sessionStorage.getItem('siteId') || '{}') : null;
    const encodedFrom = encodeURIComponent(payload?.from);
    const encodedTo = encodeURIComponent(payload?.to);
    const params = '/' + payload?.id + '/history?category=monotainer&siteId=' + siteId + '&offset=' + payload.offset + '&limit=' + payload.limit
      + '&from=' + encodedFrom + '&to=' + encodedTo;
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.entitiesDetails, params, false);
  }

  getMappingDetails(reqData: any) {
    let params = '?type=' + reqData?.type;
    if (reqData?.siteId)
      params += '&siteId=' + reqData?.siteId;
    if (reqData?.entityId)
      params += '&entityId=' + reqData?.entityId;
    if (reqData?.attribute)
      params += '&attribute=' + reqData?.attribute;
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.getMapping, params);
  }

  updateMappingDetials(reqData: any) {
    return this.httpGuard.httpReq('put', 'API_ENDPOINT', ApiConstants.URL.getMapping + '/' + reqData?._id, reqData, reqData?.isNoLoader ? false : true);
  }

  getTrendChartDetails(reqData: any, history: boolean = false) {
    const encodedFrom = encodeURIComponent(reqData?.from);
    const encodedTo = encodeURIComponent(reqData?.to);
    const params = '/' + reqData?.entityId + '/trend?from=' + encodedFrom + '&to=' + encodedTo + '&includeHistory=' + history;
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.entitiesDetails, params);
  }

  fetchRul(paramData: any) {
    const queryParam = '?entityId=' + paramData?.entityId + '&class=' + paramData?.class;
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.fetchRul, queryParam, false);
  }

  fetchRulStatus(rulValue: number, rulClass: string) {
    let statusDetails;
    const rulConfig = this.service.getConfiguration('trlRulConfig') ? this.service.getConfiguration('trlRulConfig')?.trlRulConfig?.find((item: any) => item.model === 'safari') : [];
    rulConfig?.partsLifetime?.find((item: any) => {
      if (item?.class === rulClass) {
        item?.status?.find((elem: any) => {
          if ((+rulValue >= +elem?.lowerThreshold) && (+rulValue <= +elem?.upperThreshold))
            statusDetails = elem;
        })
      }
    });
    return statusDetails;
  }

  // resetRULDetials(rulClass: string) {
  //   const rulConfig = this.service.getConfiguration('trlRulConfig') ? this.service.getConfiguration('trlRulConfig')?.trlRulConfig?.find((item: any) => item.model === 'safari') : [];
  //   return rulConfig?.partsLifetime?.find((item: any) => item?.class === rulClass);
  // }

  createRul(paramData: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.createRul, paramData, false);
  }

  rulStatistics(paramData: any, page: number) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.rulStatistics + '/' + page, paramData, false);
  }

  rulStatisticsV(paramData: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.rulStatisticsV, paramData, false);
  }

  numberOnly(event: any, hasNegativeNumber: boolean = false): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode === 101 || charCode === 69 || charCode === 43 || (charCode === 45 && !hasNegativeNumber)) {
      return false;
    }
    return true;
  }

  userOrAppNameDetails(createdBy: string) {
    const queryParam = '/' + createdBy;
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.userOrAppNameDetails, queryParam);
  }

  entityAttributeValue(paramData: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.entityAttributeValue, paramData, false);
  }

  getGeoHistory(payload: EntitySummaryPayloadModel) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.geoHistory, payload, false);
  }

  /**
   * Gets entity attribute status
   * @param payload
   * @returns
   */
  getEntityAttributeStatus(payload: AssetConditionPayloadModel) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants?.URL?.entityAttributeStatus, payload, false);
  }

  /**
   * Gets entity summary
   * @param payload
   * @returns
   */
  getEntitySummary(payload: EntitySummaryPayloadModel, isLoaderNeeded: boolean = false) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants?.URL?.getEntitySummary, payload, isLoaderNeeded);
  }

  /**
   * Gets entity aggr summary
   * @param payload 
   * @returns  
   */
  getEntityAggrSummary(payload: AggregatePayload, isLoaderNeeded: boolean = true, pageType?: string) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants?.URL?.entityAggrSummary, payload, isLoaderNeeded , 'events', pageType);
  }


  /**
   * Gets entity aggr latest list
   * @param payload 
   * @returns  
   */
  getEntityAggrLatestList(payload: {entityIds: string[], from: string, to : string}, isLoaderNeeded: boolean = true, pageType?: string) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants?.URL?.entityAggrLatest, payload, isLoaderNeeded, 'events', pageType);
  }

  getActiveDates(reqPayload: {entityId: string, count: number, from: string, to : string, profilingBasedOn ?: string}) {
    let queryParam = `/${reqPayload?.entityId}?count=${reqPayload?.count}&from=${encodeURIComponent(reqPayload?.from)}&to=${encodeURIComponent(reqPayload?.to)}`;
    if(reqPayload?.profilingBasedOn) {
      queryParam = `${queryParam}&profilingBasedOn=tripId`
    }
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.activeDates, queryParam);
  }
}
